import clsx from "clsx";

import type { DateCellDateType } from "../../date-navigation/date-cell";

export function AvailabilityCellFrame({
  dateType,
  isInternal = false,
  isCICOHighlight,
  children,
}: {
  dateType: DateCellDateType;
  isInternal?: boolean;
  isCICOHighlight: boolean;
  children: React.ReactNode;
}) {
  const isNone = !dateType.isCycleEnd && dateType.next7 === "none";
  return (
    <div
      className={clsx("w-full flex-1 grow border-r p-[2px]", {
        "border-r-skogecha-60": !isInternal && dateType.isCycleEnd,
        "border-r-skogecha-60 [border-right-style:dashed]":
          !isInternal && !dateType.isCycleEnd && dateType.next7 === "end",
        "border-r-slightbeige-116": isNone,
        "bg-[#FFCBBE]": isCICOHighlight,
      })}
    >
      {children}
    </div>
  );
}
